<template>
  <div class="section--idea-status">
    <div class="container main-content">
      <div class="row">
        <div class="col-md-10 offset-md-1" v-if="statuses.length">
          <IdeaStatusBox v-for="(status,i) in statuses" :status="status" :key="i"></IdeaStatusBox>
        </div>
        <div class="col-md-10 offset-md-1 no-content" v-if="!statuses.length && !loading">
          <span>There is no status history, yet!</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IdeaStatusBox from "../../components/ideas/IdeaStatusBox";
export default {
  name: "IdeaStatus",
  components: {IdeaStatusBox},
  computed: {
    statuses() {
      return this.$store.getters.idea._embedded.Content._embedded.ContentHistory
    }
  }
}
</script>

<style scoped>

</style>
